import { render, staticRenderFns } from "./serbestfatura.vue?vue&type=template&id=55924c0b&scoped=true&"
import script from "./serbestfatura.vue?vue&type=script&lang=js&"
export * from "./serbestfatura.vue?vue&type=script&lang=js&"
import style0 from "./serbestfatura.vue?vue&type=style&index=0&id=55924c0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55924c0b",
  null
  
)

export default component.exports